import { Component, Input, OnInit } from '@angular/core';
import { ScannableOrder } from '@app/services/orders/scannable-order';
import { ScanService } from '../../services/scan.service';
import { BatchActionsService } from '../../services/batch-actions.service';
import { TranslatedFulfillmentStatus } from '@pdqdev/pdq-shared/dist/OrderData';
import { getOrderSplitIndicesString } from '@utils/order-split-utils';

@Component({
  selector: 'app-scan-order-success',
  templateUrl: './scan-order-success.component.html',
  styleUrls: ['./scan-order-success.component.scss'],
  standalone: false,
})
export class ScanOrderSuccessComponent implements OnInit {
  @Input() order: ScannableOrder;
  nextScanOrder: ScannableOrder;
  loader = false;
  readonly TranslatedFulfillmentStatus = TranslatedFulfillmentStatus;
  orderSplitIndicesText: string;

  constructor(
    private scanService: ScanService,
    public batchActionService: BatchActionsService,
  ) {}

  ngOnInit(): void {
    if (this.order) {
      this.nextScanOrder = this.scanService.getNextScanOrder(this.order.id);
      this.orderSplitIndicesText = getOrderSplitIndicesString(this.order, 'view');
    }
  }
  scanOrder(): void {
    this.scanService.toggleScanOrderSuccessDialog(null);
    this.scanService.toggleScanInputDialog('order');
  }

  scannext(): void {
    this.loader = true;
    this.scanService
      .syncAndScanOrder(this.nextScanOrder.id, this.nextScanOrder.shippingId)
      .subscribe((scanOrder: ScannableOrder) => {
        this.scanService.toggleScanOrderSuccessDialog(null);
        this.loader = false;
        this.scanService.toggleScanOrderDialogOpened(scanOrder);
      });
  }
}
